import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';
import FeaturesContent from 'components/FeaturesContent';

const Features = observer(() => {
    const dataStore = useDataStore();
    const { unitSlug } = useParams();

    const unit = dataStore.getItem('units', 'slug', unitSlug);
    const unitType = unit ? dataStore.getItem('unit_types', 'id', unit.acf.unit_type) : null;
    const colorScheme = unitType?.acf?.color_scheme;

    if (!unit) {
        return (
            <Page>
                <p>No Unit Found</p>
            </Page>
        );
    }

    return (
        <Page>
            <FeaturesContent colorScheme={colorScheme} />
        </Page>
    );
});

export default Features;
